/**
 * @param {number|string} variantId - Shopify variant ID（/cart/add.js の id）
 * @param {number} quantity
 * @param {Object<string, string>} [properties] - ラインアイテムプロパティ（例: ギフトボックス）
 */
function addProduct(variantId, quantity, properties) {
  var qty = quantity != null ? parseInt(String(quantity), 10) : 1;
  if (isNaN(qty) || qty < 1) {
    qty = 1;
  }

  var id = parseInt(String(variantId), 10);
  if (isNaN(id)) {
    console.error('addProduct: invalid variant id');
    return;
  }

  var addData = {
    id: id,
    quantity: qty
  };

  if (properties && typeof properties === 'object') {
    var keys = Object.keys(properties);
    if (keys.length > 0) {
      addData.properties = properties;
    }
  }

  var cartAddUrl =
    window.routes && window.routes.cartAddUrl
      ? window.routes.cartAddUrl + '.js'
      : '/cart/add.js';

  fetch(cartAddUrl, {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: 'POST'
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          var msg =
            (data && (data.description || data.message)) || response.statusText;
          throw new Error(msg);
        });
      }
      return response.json();
    })
    .then(function () {
      document.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: { quantity: qty }
        })
      );
    })
    .catch(function (err) {
      console.error(err);
    });
}